import { FormValues } from './types';

export const FORM_FIELDS = {
  MEDIA: {
    name: 'media',
    label: 'Media',
  } as const,
  MESSAGE: {
    name: 'message',
    label: 'Message',
  } as const,
  NAME: {
    name: 'name',
    label: 'Name',
  } as const,
};

export const DEFAULT_VALUES: FormValues = {
  media: undefined,
  message: '',
  name: '',
};
